import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type HttpResponse = {
  id: string
  title: string
  score: number
  newKanbanStep: {
    id: string
    title: string
    sequence: 1
    tennantId: string
  }
  ideaUsers: {
    id: string
    name: string
    email: string
    image: null | string
  }
  _count: {
    ideaLikes: number
    ideaComments: number
  }
}[]

type TopFiveIdea = {
  id: string
  sequence: string
  name: string
  avatar?: string
  title: string
  currentStep: string
  score: number
  likes: number
  comments: number
}

type Params = {
  startDate?: Date
  endDate?: Date
  challenges?: string[]
}

type GetDashboardTopFiveIdeasResponse = {
  topFiveIdeas: TopFiveIdea[]
}

async function getDashboardTopFiveIdeas({
  startDate,
  endDate,
  challenges,
}: Params): Promise<GetDashboardTopFiveIdeasResponse> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      topFiveIdeas: [
        {
          id: '1c0b9881-064f-4a5e-97c3-ac6ff1af73b5',
          sequence: '1º',
          name: 'Pedro Lucas',
          title: 'Sistema de Gestão Inteligente de Resíduos',
          currentStep: 'Em Avaliação',
          score: 95,
          likes: 28,
          comments: 12,
        },
        {
          id: '26b9a677-8083-4364-8d39-340132a27c9c',
          sequence: '2º',
          name: 'Evelyn Monteiro',
          title: 'Plataforma de Experiência do Cliente Omnichannel',
          currentStep: 'Aprovada para Execução',
          score: 88,
          likes: 22,
          comments: 8,
        },
        {
          id: 'a72aeda0-bccc-4129-8353-2e59c44fcc3c',
          sequence: '3º',
          name: 'Patrick Louback',
          title: 'Automação de Processos com IA',
          currentStep: 'Em Execução',
          score: 82,
          likes: 18,
          comments: 6,
        },
        {
          id: '1884242a-8d54-480c-9fb7-3f7964f0fb68',
          sequence: '4º',
          name: 'Jessica Hakime',
          title: 'Programa de Diversidade e Inclusão Digital',
          currentStep: 'Avaliações Concluídas',
          score: 76,
          likes: 15,
          comments: 5,
        },
        {
          id: '9f3bd8c9-4a8a-49f0-9ff8-ac0cc927b473',
          sequence: '5º',
          name: 'Vinicius Arantes',
          title: 'Ferramentas de Produtividade Colaborativa',
          currentStep: 'Aguardando Análise',
          score: 71,
          likes: 12,
          comments: 4,
        },
      ],
    }
  }

  const queryParams = new URLSearchParams({
    ...(startDate && { startDate: startDate.toISOString() }),
    ...(endDate && { endDate: endDate.toISOString() }),
    ...(challenges &&
      challenges.length > 0 && { campaignIds: JSON.stringify(challenges) }),
  })

  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data } = await httpClient.get<HttpResponse>(
    `/ideas/dashboard/top-five-ideas${query}`,
  )

  const topFiveIdeas = data.map((idea, index) => {
    const { name, image } = idea.ideaUsers

    return {
      id: idea.id,
      sequence: `${index + 1}º`,
      name,
      avatar: image ?? undefined,
      title: idea.title,
      currentStep: idea.newKanbanStep.title,
      score: idea.score,
      likes: idea._count.ideaLikes,
      comments: idea._count.ideaComments,
    }
  })

  return {
    topFiveIdeas,
  }
}

export { getDashboardTopFiveIdeas, type TopFiveIdea }
